import { BehaviorSubject } from "rxjs";
import {isEmpty, forIn, unionWith, uniqBy} from 'lodash';
import LocalStorage from '../services/LocalStorage';

const LOCAL_NOTIFICATIONS_KEY = 'notifications';
const notifyForTokens = ['insufficient', 'revoked', 'teams-limited'];
const getNotificationId = (pl: string, sub: any, type: string) => {
  if (pl === 'slack') {
    return `slack-${sub.team_id}-${type}`
  }
  return `${pl}-${sub.email}-${type}`;
}
const mergeLocalNotifications = (notifications:Array<any>) => {
  const localNotifications = LocalStorage.getItem(LOCAL_NOTIFICATIONS_KEY);
  if (!localNotifications) {
    return notifications;
  }
  return uniqBy(unionWith(localNotifications, notifications, 'nId'), 'nId');
}

const NotificationsStore = {
  current$: new BehaviorSubject<Array<any>>(LocalStorage.getItem(LOCAL_NOTIFICATIONS_KEY) || []),
  addNotification(sub:any, type?:string) {
    const current = this.current$.getValue();
    const nType = type || 'token';
    const pl = sub.platform === 'office-365' && sub.teams ? 'teams' : sub.platform;
    const nId = getNotificationId(sub.platform, sub, nType);
    if (current.some((c:any) => c.nId === nId)) {
      // same notification exists
      return;
    }
    current.unshift({
      sub: { ...sub },
      account: sub.platform === 'slack' ? sub.team_name : sub.email,
      type: nType,
      read: false,
      pl,
      nId: getNotificationId(sub.platform, sub, nType),
    });
    this.current$.next(current);
  },
  markAsRead(notification?:any) {
    const current = this.current$.getValue();
    const updated = current.map((notif: any) => {
      if (!notification) {
        return {
          ...notif,
          read: true,
        }
      }
      if (notif.nId === notification.nId) {
        return {
          ...notif,
          read: true,
        }
      }
      return notif;
    });
    this.current$.next(updated);
  },
  createNotifications(subs:object) {
    let notifs:Array<any> = [];
    if (isEmpty(subs)) {
      return;
    }
    forIn(subs, (v:any, k:string) => {
      v.forEach((s:any) => {
        let account = s.email;
        let type = 'token';
        let pl = k;
        if (notifyForTokens.indexOf(s.token_status) > -1) {
          notifs.push({
            sub: { ...s },
            account: k === 'slack' ? s.team_name : s.email,
            type,
            read: false,
            pl,
            nId: getNotificationId(k, s, type)
          })
        }
        if (k === 'office-365' && s.teams) {
          pl = 'teams';
          if (s.teams_data_status === 'in-progress') {
            type = 'indexing';
            notifs.push({
              sub: { ...s },
              account,
              type,
              read: false,
              pl,
              nId: getNotificationId(pl, s, type)
            })
          }
        }
      })
    });
    const mergedNotifs = mergeLocalNotifications(notifs);
    this.current$.next(mergedNotifs);
  }
}

NotificationsStore.current$.subscribe({
  next: (value) => {
    LocalStorage.setItem(
      LOCAL_NOTIFICATIONS_KEY,
      value
    );
  }
})

export default NotificationsStore;